// Loyalty Settings CRUD
const GET_LOYALTY_SETTINGS = "GET_LOYALTY_SETTINGS";
const GET_ALL_LOYALTY_SETTINGS = "GET_ALL_LOYALTY_SETTINGS";
const ADD_LOYALTY_SETTINGS = "ADD_LOYALTY_SETTINGS";
const UPDATE_LOYALTY_SETTINGS = "UPDATE_LOYALTY_SETTINGS";
const DELETE_LOYALTY_SETTINGS = "DELETE_LOYALTY_SETTINGS";
const GET_LOYALTY_SETTINGS_BY_ENTERPRISE = "GET_LOYALTY_SETTINGS_BY_ENTERPRISE";

// Loyalty Rules Earn CRUD
const GET_ALL_LOYALTY_RULES_EARN = "GET_ALL_LOYALTY_RULES_EARN";
const GET_LOYALTY_RULES_EARN = "GET_LOYALTY_RULES_EARN";
const ADD_LOYALTY_RULES_EARN = "ADD_LOYALTY_RULES_EARN";
const UPDATE_LOYALTY_RULES_EARN = "UPDATE_LOYALTY_RULES_EARN";
const DELETE_LOYALTY_RULES_EARN = "DELETE_LOYALTY_RULES_EARN";
const GET_LOYALTY_RULES_EARN_BY_ENTERPRISE = "GET_LOYALTY_RULES_EARN_BY_ENTERPRISE";

// Customer Actions
const REDEEM_LOYALTY_POINTS = "REDEEM_LOYALTY_POINTS";
const GET_LOYALTY_LEDGER = "GET_LOYALTY_LEDGER";

module.exports = {
  // Settings
  GET_LOYALTY_SETTINGS,
  GET_ALL_LOYALTY_SETTINGS,
  ADD_LOYALTY_SETTINGS,
  UPDATE_LOYALTY_SETTINGS,
  DELETE_LOYALTY_SETTINGS,
  GET_LOYALTY_SETTINGS_BY_ENTERPRISE,
  
  // Rules Earn
  GET_ALL_LOYALTY_RULES_EARN,
  GET_LOYALTY_RULES_EARN,
  ADD_LOYALTY_RULES_EARN,
  UPDATE_LOYALTY_RULES_EARN,
  DELETE_LOYALTY_RULES_EARN,
  GET_LOYALTY_RULES_EARN_BY_ENTERPRISE,
  
  // Customer
  REDEEM_LOYALTY_POINTS,
  GET_LOYALTY_LEDGER
};